import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d338d362"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "row mb-0 mb-lg-4" }
const _hoisted_3 = { class: "w-max-content col-lg-4 col-form-label text-left text-lg-start" }
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = { class: "row mb-4" }
const _hoisted_6 = { class: "w-max-content col-lg-4 col-form-label text-left text-lg-start" }
const _hoisted_7 = { class: "col-lg-8" }
const _hoisted_8 = {
  key: 1,
  class: "d-flex justify-content-center justify-content-lg-end"
}
const _hoisted_9 = {
  key: 2,
  class: "text-danger text-end mt-2"
}
const _hoisted_10 = { class: "d-flex flex-column flex-lg-row justify-content-end mb-3 mt-5 mb-lg-5 align-items-center" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { ref, computed, onMounted } from 'vue'
import { required, email, maxLength, minLength } from '@vuelidate/validators'
import { customMaxLength } from '@/utils'
import ErrorMessage from '@/components/error-message'
import { useLogin } from '@/use/loginHelper'
import { MIN_LENGTH_EMAIL, MAX_LENGTH_EMAIL } from '@/constants/number'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import 'vue-toastification/dist/index.css'
import { useToast } from 'vue-toastification'
import TokenExpired from '@/components/token-expired/index.vue'
import { useRoute } from 'vue-router'
import RecaptCha from '@/views/shared/components/RecaptCha.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isCheckRecaptcha = `${process.env.VUE_APP_CHECK_RECAPTCHA}`

const toast = useToast()
const route = useRoute()
const reCaptChaRef = ref<InstanceType<typeof RecaptCha>>()

onMounted(() => {
  if (route.query?.token_expired)
    toast.error({
      component: TokenExpired,
    })
})

const rules = computed(() => {
  return {
    email: {
      required,
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      minLength: minLength(MIN_LENGTH_EMAIL),
      email,
    },
    password: {
      required,
      maxLength: maxLength(128),
      minLength: minLength(8),
    },
    'g-recaptcha-response-data': isCheckRecaptcha == 'false' ? '' : { required },
  }
})

const formData = ref({
  email: '',
  password: '',
  'g-recaptcha-response-data': '',
})

const handleSubmit = () => {
  submit(reCaptChaRef)
}

const { recaptchaVerified, errorLogin, disableBtn, checkCaptcha, v$, checkSubmit, submit } = useLogin(rules, formData, reCaptChaRef)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(handleSubmit, ["prevent"]),
    class: "mb-4"
  }, [
    (_unref(errorLogin))
      ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
          key: 0,
          title: _unref(translate)('systemErr')
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(translate)('email')), 1),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          readonly: "",
          onfocus: "this.removeAttribute('readonly')",
          ontouchstart: "this.removeAttribute('readonly')",
          name: "email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).email.$model) = $event)),
          class: _normalizeClass(['form-control', _unref(v$).email.$error ? 'is-invalid' : ''])
        }, null, 2), [
          [
            _vModelText,
            _unref(v$).email.$model,
            void 0,
            { trim: true }
          ]
        ]),
        _createVNode(InputErrorMessage, {
          title: 'email',
          params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
          validator: _unref(v$).email.$errors[0]?.$validator
        }, null, 8, ["params", "validator"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(translate)('password')), 1),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          name: "password",
          class: _normalizeClass(['form-control', _unref(v$).password.$error ? 'is-invalid' : '']),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).password.$model) = $event))
        }, null, 2), [
          [_vModelText, _unref(v$).password.$model]
        ]),
        _createVNode(InputErrorMessage, {
          title: 'password',
          params: [8, 128],
          validator: _unref(v$).password.$errors[0]?.$validator
        }, null, 8, ["validator"])
      ])
    ]),
    (isCheckRecaptcha !== 'false')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(RecaptCha, {
            ref: (_value, _refs) => {
              _refs['reCaptChaRef'] = _value
              reCaptChaRef.value = _value
            },
            onVerify: _unref(recaptchaVerified)
          }, null, 8, ["onVerify"])
        ]))
      : _createCommentVNode("", true),
    (_unref(checkSubmit) && !_unref(checkCaptcha))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(translate)('SA80errorGGreCaptcha')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(Button, {
        title: _unref(translate)('titleButtonLogin'),
        type: 'secondary',
        htmlType: 'submit',
        disabled: _unref(disableBtn)
      }, null, 8, ["title", "disabled"])
    ])
  ], 40, _hoisted_1))
}
}

})